import ContainerConfig from './model/ContainerConfig';
import Base from './Base';
import Cell from './Cell';
import Container from './Container';
import { drag, resize } from './directives';
import { ControlConfig } from './model';

export default {
    name: "ConfigView",
    extends: Base,
    directives: { drag, resize },
    render(h) {
        let _children = [];

        if (this.layoutConfig instanceof ContainerConfig) {
            _children.push(
                <Container
                    key={this.layoutConfig.ID}
                    props={{ config: this.config, layoutConfig: this.layoutConfig }}
                    scopedSlots={this.$scopedSlots}
                >
                    {
                        this.layoutConfig.Children.map(child => (
                            <ConfigView
                                props={{ config: this.config, layoutConfig: child }}
                                scopedSlots={this.$scopedSlots}
                            />)
                        )
                    }
                </Container>
            );
        } else {
            _children.push(
                <Cell
                    key={this.layoutConfig.ID}
                    props={{ config: this.config, layoutConfig: this.layoutConfig }}
                    scopedSlots={this.$scopedSlots}
                />
            );
        }

        return (<div class="cmn-grid-control-wrapper" style={this.GetGridLayoutStyle()}>{_children}</div>);
    }
};